const colorTokens = {
    primary: {
        100: '#fdfefe',
        200: '#eef4f4',
        300: '#dae8e8',
        400: '#bcd7d8',
        500: '#75b7ba',
        600: '#25a4a8',
        650: '#118185',
        700: '#34797b',
        800: '#326061',
        900: '#2d4e4f',
        1000: '#223334',
        opacity: 'rgba(52, 121, 123, 0.4)',
    },
    success: {
        100: '#fdfefd',
        200: '#e8f7ea',
        300: '#c7efcc',
        400: '#90e59c',
        500: '#2dc55a',
        600: '#3aa853',
        650: '#3b7c45',
        700: '#3b7c45',
        800: '#36633b',
        900: '#2f4f32',
        1000: '#233523',
    },
    info: {
        100: '#fdfdfe',
        200: '#eef3f8',
        300: '#d9e6f3',
        400: '#bad5ee',
        500: '#69b2f2',
        600: '#259aee',
        650: '#3773a5',
        700: '#3773a5',
        800: '#355c7f',
        900: '#2f4a64',
        1000: '#23313f',
    },
    warning: {
        100: '#fefefc',
        200: '#f9f3dc',
        300: '#f9e3a9',
        400: '#fdcb50',
        500: '#d7a421',
        600: '#b88e29',
        650: '#866b2b',
        700: '#866b2b',
        800: '#695628',
        900: '#554724',
        1000: '#382f1b',
    },
    danger: {
        100: '#fefdfd',
        200: '#fbf1f1',
        300: '#fadfdd',
        400: '#fcc5c0',
        500: '#ff8b83',
        600: '#ff5c59',
        650: '#DF0400',
        700: '#d12f34',
        800: '#9f3130',
        900: '#7e2e2b',
        1000: '#4f2320',
    },
    grey: {
        100: '#fefefe',
        200: '#f3f3f3',
        300: '#e5e5e5',
        400: '#d2d2d2',
        500: '#acacac',
        600: '#949494',
        650: '#747373',
        700: '#6f6f6e',
        800: '#595858',
        900: '#494948',
        1000: '#313130',
        opacity: 'rgba(111,111,110,0.40)',
    },
};

export { colorTokens };
//# sourceMappingURL=colors.js.map
